module.exports = __webpack_public_path__ + "image/leaf_img2.png";